import React from 'react';
import { BundleDetailTemplate } from './BundleDetailTemplate';

export const BundleTermination = () => <BundleDetailTemplate slug="termination-offboarding" />;
